export default "__VITE_ASSET__BXgkJgDF__"